<a href="Javascript://" (click)="sortBy()">{{ label }} <i class="fas fa-sort"></i></a>
